import styled from '@emotion/styled';
import { Color, FilledInfoIcon } from '@liveoptics/react-ui';
import React, { useCallback } from 'react';
import { OpportunityMode } from '../../../enums';
import { OpportunityModeDropDownMenu } from '../../menus';

export interface NoOpportunitiesFoundSubFormProps {
  defaultOpportunityMode?: OpportunityMode;
  onOpportunityModeChange: (opportunityMode: OpportunityMode) => void;
}

const NoOpportunitiesMessage = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: ${Color.blue100} 0% 0% no-repeat padding-box;
  border: 1px solid ${Color.blue400};
  opacity: 1;
  font: normal normal 600 12px/15px Open Sans;
  text-align: left;
  letter-spacing: 0.28px;
  color: ${Color.coolGray700};
  opacity: 1;
  margin-bottom: 32px;
`;

const BlueInfoIcon = styled(FilledInfoIcon)`
  fill: ${Color.blue400};
  color: ${Color.blue400};
  margin: 16px;
  margin-bottom: 32px;
`;

const SubTitle = styled.p`
  margin-bottom: 8px !important;
  margin-top: 16px !important;
  text-align: left;
  font: normal normal normal 14px/17px Open Sans;
  letter-spacing: 0.28px;
  color: ${Color.coolGray700};
  opacity: 1;
`;

const OpportunitiesContainer = styled.div`
  margin-top: 16px;
`;

export const NoOpportunitiesFoundSubForm = (props: NoOpportunitiesFoundSubFormProps) => {
  const handleOpportunityModeChange = useCallback(
    (value: string) => props.onOpportunityModeChange?.(OpportunityMode[value]),
    [props]
  );

  return (
    <div>
      <OpportunitiesContainer>
        <NoOpportunitiesMessage>
          <BlueInfoIcon></BlueInfoIcon>
          No salesforce.com opportunities are associated with this account.
          <br />
          Please login to salesforce.com to create a new opportunity.
        </NoOpportunitiesMessage>
      </OpportunitiesContainer>
      <div>
        <SubTitle>Activity not tied to opportunity</SubTitle>
        <OpportunityModeDropDownMenu
          defaultValue={
            props.defaultOpportunityMode &&
            props.defaultOpportunityMode !== OpportunityMode.None &&
            props.defaultOpportunityMode !== OpportunityMode.Assigned
              ? props.defaultOpportunityMode
              : undefined
          }
          onChange={handleOpportunityModeChange}
        />
      </div>
    </div>
  );
};
